<template>
  <section>
    <form method="post" @submit.prevent="send">
      <form-wrapper :validator="$v.form">
        <form-group
          horizontal
          name="notify_title"
          :label="$t('attributes.order_notify_title')"
        >
          <b-input
            v-model="form.notify_title"
            @input="$v.form.notify_title.$touch()"
            name="notify_title"
            :placeholder="
              $t('message.please_input') + $t('attributes.order_notify_title')
            "
            expanded
          >
          </b-input>
        </form-group>
        <form-group
          horizontal
          name="notify_content"
          :label="$t('attributes.order_notify_content')"
        >
          <b-input
            v-model="form.notify_content"
            type="textarea"
            name="notify_content"
            rows="10"
            @input="$v.form.notify_content.$touch()"
            :placeholder="
              $t('message.please_input') + $t('attributes.order_notify_content')
            "
            expanded
          >
          </b-input>
        </form-group>

        <b-field horizontal>
          <b-button :loading="sending" type="is-primary" native-type="submit">
            {{ $t('attributes.update') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>
  </section>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'ActivityNotifyForm',

  props: {
    sending: {
      type: Boolean,
      default: true
    },
    id: {
      type: Number,
      default: null
    },
    notify_title: {
      type: String,
      default: ''
    },
    notify_content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        id: this.id,
        notify_title: this.notify_title,
        notify_content: this.notify_content
      }
    }
  },
  validations: {
    form: {
      notify_title: { maxLength: maxLength(250) },
      notify_content: {}
    }
  },
  watch: {
    id() {
      this.form = {
        id: this.id,
        notify_title: this.notify_title,
        notify_content: this.notify_content
      }
    }
  },
  methods: {
    async send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('onSend', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  min-height: 480px;
}
</style>
